<template>
  <div class="primary"></div>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>
div {
  height: 1px;
}
</style>